export default {
      id: "ic_recherche-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_recherche-usage",
      toString: function () {
        return this.url;
      }
    }